module.exports = __webpack_public_path__ + "static/images/styles/images/icons/warning.08a998e4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/warning.png
// module id = 3645
// module chunks = 11